export default __webpack_public_path__ + "static/media/distraction.bc3dd863.png";